import React, { useEffect, useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useParams } from 'react-router-dom';
import useGetApi from '../../services/useGetApi';
import usePost from '../../services/usePost';

const BbbClasses = () => {
    const { id } = useParams(); 
    const [form] = Form.useForm();
    const [isPostLoading, postError, postData] = usePost();
    const [
        bbcMeetingIsLoading,
        bbcMeetingError,
        bbcMeetingData,
        getBbcMeeting,
    ] = useGetApi(`course/bbb-live-class/${id}`, [], true); 

    const [bbbMeeting, setBbbMeeting] = useState(null);

    // useEffect(() => {
    //     console.log(bbbMeeting,'...............')
    // },[bbbMeeting])

    
    useEffect(() => {
        if (id) {
            getBbcMeeting(`course/bbb-live-class/${id}`); 
        }
    }, [id]);

    useEffect(() => {

            if (bbcMeetingData) {
            
                setBbbMeeting(bbcMeetingData);

                form.setFieldsValue({
                  meetingId : bbcMeetingData?.meetingId,
                  moderatorPassword: bbcMeetingData?.moderatorPassword,
                  viewerPassword: bbcMeetingData?.viewerPassword,
                  instructionsForStudents: bbcMeetingData?.instructionsForStudents
                })
            } else {
                
                setBbbMeeting({
                    "courseId": id,
                    "meetingId": "",
                    "moderatorPassword": "",
                    "viewerPassword": "",
                    "instructionsForStudents": ""
                });
            }
     
    }, [bbcMeetingData,form]); 

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log(name,'name')
        setBbbMeeting((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };


    const handleSaveMeetingInfo = async (values) => {
        // console.log(values,'valll')
        const dataToSent = {
            id:id,
            meetingId : values?.meetingId,
            moderatorPassword: values?.moderatorPassword,
            viewerPassword: values?.viewerPassword,
            instructionsForStudents: values?.instructionsForStudents
        }
        try {
            const response = await postData(`course/bbb-live-class/${id}`, dataToSent, true); 
            if (response) {
                message.success('Meeting info saved successfully!');
            } else {
                message.error('Failed to save meeting info.');
            }
        } catch (error) {
            message.error('Error saving meeting info.');
        }
    };

    // useEffect(() => {
    //     console.log(bbbMeeting,'...')
    // },[bbbMeeting])

    return (
        <div className='bbc_live_tab'>
           <div className='bbc_live_left'>
                <Form 
                  form={form} 
                  layout="vertical" 
                  onFinish={handleSaveMeetingInfo} 
                >
         
                <Form.Item label="Meeting ID" name="meetingId" 
                   rules={[{ required: true, message: "Please input meeting id" }]}
                >
                    <Input
                        className='bbc_input_box'
                    />
                </Form.Item>


                <Form.Item label="Moderator Password" name="moderatorPassword" 
                  rules={[{ required: true, message: "Please input meeting moderator password!" }]}
                >
                    <Input
                        className='bbc_input_box'
                    />
                </Form.Item>

          
                <Form.Item label="Viewer Password" name="viewerPassword" 
                  rules={[{ required: true, message: "Please input meeting viewer password!" }]}
                >
                    <Input
                        className='bbc_input_box'
                    />
                </Form.Item>


                <Form.Item label="Instructions" name="instructionsForStudents" 
                  rules={[{ required: true, message: "Please input instructions for student!" }]}
                >
                    <TextArea
                        rows={4}
                        className='bbc_input_box'
                    />
                </Form.Item>

                <Form.Item>
                   
                <button
                    className='bbc_save_meeting_btn'
                    type="primary"
                    htmlType="submit"
                    loading={isPostLoading}
                    >
                     Save meeting info
                </button>
                   
                </Form.Item>
              </Form>
            </div>

            {/* Right Section */}
            <div className='bbc_live_right'>
                <div className='bbc_live_right_card'>
                <h5>Attention!</h5>
                <p>Give some instructions to keep your students informed about the meeting</p>
                </div>

                {/* Start Meeting Button */}
                <Button className='bbc_start_meeting_btn'>
                Start meeting
                </Button>
            </div>
        </div>
    );
};

export default BbbClasses;
